import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  creativeCard: {
    margin: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    minWidth: 270,
    width: '100%',
    maxWidth: 500,
    position: 'relative',
  },
  notify: { marginTop: 10, color: theme.palette.primary.main },
  imageThumb: {
    height: 54,
    width: '20%',
    marginLeft: 2,
    marginRight: 2,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  divider: {
    width: '60%',
    borderTop: '1px solid #ddd',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: 6,
    marginTop: 6,
  },
  summary: { paddingBottom: 6, paddingLeft: 10, paddingRight: 10 },
  title: {
    paddingBottom: 6,
    paddingLeft: 10,
    paddingRight: 10,
    fontWeight: '700',
  },
  meta: { fontStyle: 'italic', marginBottom: 6, fontSize: 12 },
  jobName: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: 16,
    marginTop: 5,
    marginBottom: 5,
  },
}));
